import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { useMediaQuery } from "../../../hooks";
import { CloseSmallLinear } from "../../../icons";
import { ButtonBase } from "../../../internal/ButtonBase";
import { alignmentsMap, TextBase } from "../../../internal/TextBase";
import { getMethodsForTestId } from "../../../utils/getMethodsForTestId";
import { isFunc } from "../../../utils/type";
import { directions, views } from '../../constants';
import { TechnicalMessageArrow } from '../TechnicalMessageArrow';
import styles from './TechnicalMessageAlert.css';
var cx = classNames.bind(styles);

var getAlign = function getAlign(align, view, isMobile) {
  if (align) {
    return align;
  }

  return isMobile || view === views.flipping ? alignmentsMap.left : alignmentsMap.right;
};

export var TechnicalMessageAlert = function TechnicalMessageAlert(_ref) {
  var _ref$view = _ref.view,
      view = _ref$view === void 0 ? 'single' : _ref$view,
      children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      _ref$disabledNext = _ref.disabledNext,
      disabledNext = _ref$disabledNext === void 0 ? false : _ref$disabledNext,
      _ref$disabledPrev = _ref.disabledPrev,
      disabledPrev = _ref$disabledPrev === void 0 ? false : _ref$disabledPrev,
      _ref$hideCloseButton = _ref.hideCloseButton,
      hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
      onClose = _ref.onClose,
      onPrev = _ref.onPrev,
      onNext = _ref.onNext,
      onShow = _ref.onShow,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible,
      counterText = _ref.counterText,
      namespace = _ref.namespace,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align;
  var breakpoints = useMediaQuery('xs');
  var isMobile = breakpoints.xs;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'alert'),
      getTestId = _getMethodsForTestId.getTestId;

  useEffect(function () {
    if (visible && isFunc(onShow)) {
      onShow();
    }
  }, [onShow, visible]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('root', "type_".concat(type), "view_".concat(view), {
      visible: visible
    })
  }, getTestId()), view === views.flipping && /*#__PURE__*/React.createElement("div", {
    className: cx('prev')
  }, /*#__PURE__*/React.createElement(TechnicalMessageArrow, {
    direction: directions.prev,
    onClick: onPrev,
    type: type,
    disabled: disabledPrev
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('content', {
      has_close_button: onClose
    })
  }, /*#__PURE__*/React.createElement(TextBase, {
    as: "div",
    size: isMobile ? undefined : 'l',
    alignment: getAlign(align, view, isMobile)
  }, children)), view === views.flipping && /*#__PURE__*/React.createElement("div", {
    className: cx('actions')
  }, /*#__PURE__*/React.createElement(TextBase, {
    size: "m",
    color: "N100"
  }, counterText), /*#__PURE__*/React.createElement("div", {
    className: cx('next')
  }, /*#__PURE__*/React.createElement(TechnicalMessageArrow, {
    direction: directions.next,
    onClick: onNext,
    type: type,
    disabled: disabledNext
  }))), !hideCloseButton && onClose && /*#__PURE__*/React.createElement(ButtonBase, _extends({
    onClick: onClose,
    className: cx('close')
  }, getTestId('close')), /*#__PURE__*/React.createElement(CloseSmallLinear, null)));
};